// extracted by mini-css-extract-plugin
module.exports = {"container":"DataTableWithSidebar_container__H09ZK","tableWrapper":"DataTableWithSidebar_tableWrapper__2jwPZ"};